import {
	createContext,
	useContext,
	useMemo,
	type FunctionComponent,
	type PropsWithChildren,
} from 'react';

import type { SubscriptionConfigContextType, SubscriptionProviderProps } from './types';

const SubscriptionConfigContext = createContext<SubscriptionConfigContextType>({
	subscription: undefined,
});

export const StableSubscriptionConfigProvider: FunctionComponent<
	PropsWithChildren<SubscriptionProviderProps>
> = ({ subscription, children }) => {
	const memoizedValue = useMemo(
		() => ({
			subscription,
		}),
		[subscription],
	);

	return (
		<SubscriptionConfigContext.Provider value={memoizedValue}>
			{children}
		</SubscriptionConfigContext.Provider>
	);
};

export const useSubscriptionConfig = (): SubscriptionConfigContextType => {
	return useContext(SubscriptionConfigContext);
};
